/**
 * Utility functions for currency formatting
 * Updated to use thousands (K) convention as the primary display format
 */

export const formatCurrency = (amount: number | undefined, decimals = 0): string => {
  if (amount === undefined || amount === null) return '-';
  
  // Always display in thousands with K suffix
  if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(decimals)}K`;
  }
  
  // For amounts less than 1000, show without suffix
  return `$${amount.toFixed(decimals)}`;
};

export const formatCurrencyDetailed = (amount: number | undefined): string => {
  if (amount === undefined || amount === null) return '-';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

/**
 * Format currency with intelligent abbreviations for better readability
 * Uses M for millions, K for thousands
 */
export const formatCurrencyShort = (amount: number | undefined): string => {
  if (amount === undefined || amount === null) return '-';
  
  if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}M`;
  } else if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(0)}K`;
  }
  return `$${Math.round(amount).toLocaleString()}`;
};

export const formatNumber = (num: number | undefined, decimals = 0): string => {
  if (num === undefined) return '-';
  return num.toLocaleString(undefined, { 
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

export const formatPercentage = (num: number | undefined, decimals = 1): string => {
  if (num === undefined) return '-';
  return `${formatNumber(num, decimals)}%`;
};
